/**
 * Componente genérico para renderear una celda de columna Native o Tag
 * configurada via columnConfig. Aplica el format declarado.
 *
 * Spec: docs/architecture/COLUMN_CONFIG_PROPOSAL.md
 */
import React from 'react';
import { formatValue, ColumnFormat } from '../../utils/columnFormatters';

interface GenericCellProps {
  value: unknown;
  config: ColumnFormat;
}

export const GenericCell: React.FC<GenericCellProps> = ({ value, config }) => {
  const text = formatValue(value, config);
  // Empty values rendered as muted span (consistente con el resto de la app)
  if (text === '—') {
    return <span className="text-gray-400">—</span>;
  }
  return <span>{text}</span>;
};

export default GenericCell;
